<template>
  <div>
    <div class="w3-container w3-center w3-margin-bottom w3-margin-top zero-right">
                        <span class="table-count w3-col w-30pc w3-right w3-right-align flow-blue-color w3-medium w3-padding"
                              v-html="$t('showingAppointments', {number: sortedAndFilteredPatients.length})">
                        </span>

      <div class="w3-left">
                            <span v-for="status in getAllStatuses().reverse()"
                                  class="w3-ripple flow-position-relative physician-patients-filter"
                                  @click="selectStatusFilter(status)"
                                  v-bind:class="selectedStatuses && selectedStatuses.includes(status) ? 'active' : ''">
                <patient-status
                        class="w3-xlarge w3-show-inline-block w3-margin-right cursor-pointer transform-animation"
                        :status="status">
                </patient-status>
                <i class="active-check fa fa-check-circle flow-green-active-color w3-animate-opacity w3-large">
                </i>
            </span>
      </div>
    </div>

    <div class="w3-col flow-card blue-top w3-padding">
      <table class="w3-table w3-bordered flow-table patients-table">
        <thead class="">
        <th>{{ $t("time") }}</th>
        <th>{{ $t("patient") }}</th>
        <th>{{ $t("appointment") }}</th>
        <th>{{ $t("tag") }}</th>
        <th>{{ $t("location") }}</th>
        </thead>

        <tbody v-show="patients.length === 0">
        <tr>
          <td colspan="8" class="w3-center flow-blue-color">
            <b class="font-size-1pt25em">{{$t("noPatients")}}</b>
          </td>
        </tr>
        </tbody>

        <tbody v-show="patients.length !== 0">
        <tr v-for="patient in sortedAndFilteredPatients">
          <td>
            {{ patient.appointmentTime }}
          </td>

          <td class="primary" @click="patientSelected(patient)">
            <patient-status class="w3-show-inline-block w3-margin-right"
                            :status="patient.status" :showMarker="true"></patient-status>
            <span>{{patient.comment ? trim(patient.patientName) : patient.patientName}}</span>

              <span v-if="loggedIn(patient) && !openPatientCard">
                <i class="fa fa-mobile-alt flow-margin-right flow-green-active-color flow-padding-left" :title="$t('loggedIn')"></i>
              </span>

            <span v-if="patient.comment && !openPatientCard"
                  class="w3-text-black font-weight-normal"> ({{ trim(patient.comment) }})</span>
          </td>

          <td>
            <span v-if="patient.physician">{{ patient.physician.name }} - </span>
            <span v-if="patient.consultationGroup" class="consultation-group">{{ patient.consultationGroup.displayName }} </span>
            <span v-if="patient.consultationRoom"
                  class="consultation-room flow-btn w3-round-medium font-weight-bold">
                    {{ patient.consultationRoom.displayName }}
                </span>
          </td>

          <td>
            {{ patient.ticket }}
          </td>

          <td>
            <span v-if="patient.latestPosition">{{ patient.latestPosition.displayName }}</span>
            <span v-else></span>
          </td>

          <td>
            <!--Various actions depending on status-->

            <span v-if="!isStatusLeftConsultation(patient.status) ">

                    <!--if patient is in waiting area-->
                    <span v-if="currentRoom && currentRoom.group.autoCallPatients === false && isStatusAtWaitingArea(patient.status)">
                        <span v-if="callingPatient !== patient.appointmentId"
                              @click="manuallyCallAppointment(patient)"
                              class="w3-padding-small cursor-pointer">
                            <i class="fa fa-bullhorn w3-text-pink w3-medium"
                               :title="$t('callPatient')"></i>
                        </span>

                        <span v-else>
                            <i class="fa fa-spinner w3-spin w3-large w3-opacity w3-disabled transform-animation"></i>
                        </span>
                    </span>

              <!--if patient is in the room-->
                    <span v-if="currentRoom && isStatusInConsultation(patient.status)">
                        <span v-for="action in roomActionsList(patient)"
                              v-if="exitingPatient !== patient.appointmentId && action.id === 'endConsultationCDC'"
                              @click="runRoomAction(action, patient)"
                              class="w3-padding-small cursor-pointer">
                            <i class="fa fa-sign-out-alt flow-green-active-color w3-large"
                               :title="$t('endConsultation')"></i>
                        </span>

                      <span v-else>
                      <i class="fa fa-spinner w3-spin w3-large w3-opacity w3-disabled transform-animation"></i>
                      </span>
                    </span>

              <!--if patient is in leaving status-->
                    <span v-if="currentRoom && isAssistedExit(patient) && isStatusLeavingConsultation(patient.status)">
                        <span v-if="forceExitingPatient !== patient.appointmentId"
                              @click="moveOutOfConsultation(patient)"
                              class="w3-padding-small cursor-pointer">
                            <i class="fa fa-sign-out-alt w3-text-deep-orange w3-large"
                               :title="$t('MoveOutOfConsultation')"></i>
                        </span>

                      <span v-else>
                      <i class="fa fa-spinner w3-spin w3-large w3-opacity w3-disabled transform-animation"></i>
                      </span>
                    </span>

                  </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import PatientStatus from "../common/PatientStatus";
    import {EventBus} from "../../main";

    const frc = Vue.prototype.$frc;

    export default {
        name: "PatientsForCallerMinimalRoom",
        components: {PatientStatus},
        props: ['patients', 'onSelectCallback', 'openPatientCard', 'currentRoom', 'physician', 'roomActions'],
        data: function () {
            return {
                sortedAndFilteredPatients: [],
                selectedStatuses: [],
                manualCallInProgress: false,
                callingPatient: undefined,
                forceExitingPatient: undefined,
                exitingPatient: undefined
            }
        },
        mounted() {
            this.sortedAndFilteredPatients = this.patients;
            this.selectedStatuses = Vue.getOngoingStatusFilters();

            EventBus.$on("patientUpdated", this.updatePatientEntry);
            EventBus.$on("priorityUpdated", this.updatePatientEntryOnPriority);
            EventBus.$on("appointmentDeleted", this.updatePatientEntry);
            EventBus.$on("appointmentAdded", this.updatePatientEntryOrAdd);
            EventBus.$on("Relocated", this.updatePatientEntry);
        },
        beforeDestroy() {
            EventBus.$off("patientUpdated", this.updatePatientEntry);
            EventBus.$off("priorityUpdated", this.updatePatientEntryOnPriority);
            EventBus.$off("appointmentDeleted", this.updatePatientEntry);
            EventBus.$off("appointmentAdded", this.updatePatientEntryOrAdd);
            EventBus.$off("Relocated", this.updatePatientEntry);
        },
        watch: {
            patients(newVal, oldVal) {
                if (newVal) {
                    this.sortedAndFilteredPatients = this.applyFilters(newVal);
                } else {
                    this.sortedAndFilteredPatients = newVal;
                }
            },
            selectedStatuses(newVal, oldVal) {
                if (!newVal) {
                    return;
                }
                this.sortedAndFilteredPatients = this.applyFilters(this.patients);
                Vue.saveOngoingStatusFilters(newVal);
            },
        },
        methods: {
            loggedIn(patient) {
                var res = Vue.getValueForKey(patient.patientProperties.entry, 'device');
                return res;
            },
            patientSelected(patient) {
                var device = this.loggedIn(patient) ? true : false;
                this.onSelectCallback({
                    id: patient.patientId,
                    name: patient.patientName,
                    internalIds: patient.internalIds,
                    status: patient.status,
                    device: device
                });
            },
            manuallyCallAppointment(patient) {
                var app = this;
                app.callingPatient = patient.appointmentId;
                var availableRooms = [];
                if (this.physician && this.physician.status === "Paused") {
                    app.callingPatient = undefined;
                    Vue.notifyError({title: app.$t("resumeConsultationsToCall")});
                } else {
                    frc.getPermittedPositions(patient.patientId, patient.appointmentId).then(function (res) {
                        availableRooms = res.data;
                        if (availableRooms.length > 0) {
                            frc.manuallyCallAppointment(Vue.prototype.$currentWard.id, availableRooms[0].id, patient.appointmentId).then(function (res) {
                                Vue.notifySuccess({title: app.$t("patientCalled")});
                                app.callingPatient = undefined;
                                app.updatePatientEntry(patient.patientId);
                            }).catch(function (ex) {
                                app.callingPatient = undefined;
                            });
                        } else {
                            Vue.notifyError({title: app.$t("allRoomsOccupied")});
                            app.callingPatient = undefined;
                        }
                    }).catch(function (ex) {
                        console.log(ex);
                    })
                }
            },
            trim(comment) {
                if (comment && comment.length > 30) {
                    return comment.slice(0, 30) + "...";
                }

                return comment;
            },
            selectStatusFilter(status) {
                if (!this.selectedStatuses) {
                    this.selectedStatuses = [];
                }

                var index = this.selectedStatuses.indexOf(status);

                if (index > -1) {
                    this.selectedStatuses.splice(index, 1);
                } else {
                    this.selectedStatuses.push(status);
                }
            },
            applyFilters(patients) {
                return patients.filter(this.containsStatus);
            },
            containsStatus(patient) {
                if (!patient) {
                    return false;
                }

                if (!this.selectedStatuses) {
                    return true;
                }

                return this.selectedStatuses.includes(patient.status);
            },
            updatePatientEntryOnPriority(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id, patientId).then(function (res) {
                    app.setPatientEntry(patientId, res.data);
                });
            },
            updatePatientEntry(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id, patientId).then(function (res) {
                    if (!res.data) {
                        console.log("Nothing fetched. Will remove this entry if exists.");
                        app.setPatientEntry(patientId, undefined);
                        return;
                    }
                    app.setPatientEntry(patientId, res.data);
                });
            },
            updatePatientEntryOrAdd(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id, patientId).then(function (res) {
                    if (!res.data) {
                        console.log("Nothing fetched. Will remove this entry if exists.");
                        app.setPatientEntry(patientId, undefined);
                        return;
                    }

                    app.setPatientEntry(patientId, res.data);

                    if (!app.patientFound) {
                        app.patients.push(res.data);
                    }
                });
            },
            setPatientEntry(index, patient) {
                this.patientFound = false;
                for (var i = 0; i < this.patients.length; i++) {
                    if (this.patients[i] && this.patients[i].patientId === index) {
                        this.$set(this.patients, i, patient);
                        this.patientFound = true;
                        break;
                    }
                }
            },
            runRoomAction(roomAction, patient) {
                const app = this;
                app.exitingPatient = patient.appointmentId;

                frc.runRoomAction(Vue.prototype.$currentWard.id, this.currentRoom.id, patient.appointmentId, roomAction.id).then(function (res) {
                    Vue.notifySuccess({
                        title: app.$t("success"),
                        message: roomAction.displayName
                    });
                    app.exitingPatient = undefined;
                    app.updatePatientEntry(patient.patientId);
                }).catch(function (ex) {
                    app.exitingPatient = undefined;
                })
            },
            moveOutOfConsultation(patient) {
                var app = this;
                app.forceExitingPatient = patient.appointmentId;
                frc.safelyMoveOutOfConsultation(patient.patientId, patient.appointmentId).then(function (res) {
                    Vue.notifySuccess({
                        title: app.$t('successfullyUpdated')
                    });
                    app.forceExitingPatient = undefined;
                    app.updatePatientEntry(patient.patientId);
                }).catch(function (ex) {
                    console.log(ex);
                    app.forceExitingPatient = undefined;
                })

            },
            isAssistedExit(appointment) {
                return this.currentRoom
                    && this.currentRoom.assisted === false
                    && appointment
                    && appointment.status === "LeavingConsultation";
            },
            roomActionsList(patient) {
                return this.isAssistedExit(patient) ? [] : this.roomActions;
            }
        }

    }
</script>

<style scoped>
  .physician-patients-filter.active i.active-check {
    visibility: visible;
  }

  .physician-patients-filter i.active-check {
    visibility: hidden;
  }

  .physician-patients-filter {
    opacity: 0.4;
  }

  .physician-patients-filter.active {
    opacity: 1;
    border-color: #2ea878;
  }

  .physician-patients-filter.active div, .physician-patients-filter.active span {
    border: grey thin solid;
  }

  .physician-patients-filter .fa-check-circle {
    position: absolute;
    right: 8px;
  }
</style>